import { Link, useSearchParams } from 'react-router-dom';

import { Alert } from '@/shared/ui';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';
import { useConfirmEmailChange } from '../api/use-auth.query';
import { toUserMessage } from '@platform/api-client';

/**
 * 이메일 변경 확정 콜백 View.
 *   {FRONT}/auth/confirm-email-change?token=xxxx
 * 메일 링크 클릭 시 토큰으로 변경을 확정한다(1회). 성공 시 재로그인 안내.
 */
export function ConfirmEmailChangeView() {
  const [params] = useSearchParams();
  const token = params.get('token');

  const { isPending, isSuccess, isError, error } = useConfirmEmailChange(token);
  const isProcessing = !!token && isPending;

  return (
    <div className="mx-auto w-full max-w-md py-10 text-center">
      <h1 className="mb-4 text-2xl font-bold text-adobe-dark">이메일 변경</h1>

      {!token && (
        <Alert tone="error">
          유효하지 않은 링크입니다. 메일에 포함된 링크를 다시 확인해주세요.
        </Alert>
      )}

      {isProcessing && (
        <p className="text-adobe-muted">이메일 변경을 처리하고 있습니다…</p>
      )}

      {isSuccess && (
        <>
          <Alert tone="success">
            이메일이 변경되었습니다. 보안을 위해 다시 로그인해 주세요.
          </Alert>
          <Link
            to={PATHS.LOGIN}
            className="mt-6 inline-block rounded-lg bg-brand-500 px-6 py-2.5 font-bold text-white transition-colors hover:bg-brand-600"
          >
            로그인 페이지로 이동
          </Link>
        </>
      )}

      {isError && (
        <>
          <Alert tone="error">{toUserMessage(error)}</Alert>
          <p className="mt-4 text-sm text-adobe-muted">
            링크가 만료되었거나 이미 사용된 경우, 마이페이지에서 다시 요청해주세요.
          </p>
        </>
      )}
    </div>
  );
}
